import React from 'react';
import { LanguageKeys, LANGUAGE_KEYS, RegionKeys, REGION_KEYS } from 'src/core/provider/AppMeta';

interface LocaleFilterContextValue {
    allowedLanguages: readonly LanguageKeys[];
    allowedRegions: readonly RegionKeys[];
    filterByAddresses: boolean;
}

export const LocaleFilterContext = React.createContext<LocaleFilterContextValue>({
    allowedLanguages: LANGUAGE_KEYS,
    allowedRegions: REGION_KEYS,
    filterByAddresses: true,
});
